import { Grid, InputAdornment, TextField } from '@mui/material';
import { useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { CameraForm } from './CameraForm';
import EmailIcon from '@mui/icons-material/Email';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import get from 'lodash.get';

export function Email({ index, remove }: { index: number; remove: (index: number) => void }) {
  const { register, formState } = useFormContext<CameraForm>();
  const handleDelete = (index: number) => {
    return () => {
      remove(index);
    };
  };
  const errors: any = formState.errors;
  const { ref, onChange, onBlur, name } = register(`emails.${index}` as `emails.0`, {
    pattern: { value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/, message: 'Enter a valid e-mail' },
  });
  const error = get(errors, name);

  return (
    <Grid item xs={12}>
      <TextField
        fullWidth
        variant="standard"
        error={!!error}
        label="notification e-mail"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <EmailIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" onClick={handleDelete(index)} style={{ cursor: 'pointer' }}>
              <RemoveCircleIcon />
            </InputAdornment>
          ),
        }}
        inputRef={ref}
        name={name}
        onChange={onChange}
        onBlur={(evt) => {
          if (evt.target.value == '') remove(index);
          else onBlur(evt);
        }}
        helperText={error ? error.message : null}
      />
    </Grid>
  );
}

function NewEmails({ append }: { append: any }) {
  const [isDirty, setDirty] = useState(false);
  const [current, setCurrent] = useState(0);
  const handleChange = (evt: any) => {
    setDirty(!!evt.target.value);
  };
  const handleBlur = (evt: any) => {
    if (evt.target.value) {
      append(evt.target.value);
      setCurrent((v) => (v == 0 ? 1 : 0));
    }
    evt.target.value = '';
    setDirty(false);
  };
  const createInput = (index: number) => {
    return (
      (isDirty || current == index) && (
        <Grid key={index} item xs={12}>
          <TextField
            fullWidth
            variant="standard"
            label="notification e-mail"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={
              ((isDirty && current != index) || !isDirty) && 'Enter e-mail to be notified when camera is offline'
            }
          />
        </Grid>
      )
    );
  };
  const inputs = [0, 1];
  if (current == 1) inputs.reverse();
  return <>{inputs.map((index) => createInput(index))}</>;
}

export default function Emails() {
  const {
    field: { value, onChange },
  } = useController({ name: 'emails' });
  const remove = (index: number) => {
    onChange(value.filter((email: string, _index: number) => index != _index));
  };
  const append = (email: string) => {
    onChange([...value, email]);
  };
  return (
    <>
      {[...value].map((email: string, index: number) => (
        <Email key={index} index={index} remove={remove} />
      ))}
      <NewEmails append={append} />
    </>
  );
}
